import * as React from 'react';
export const troySvg = React.forwardRef(function troySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#221E1F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.83 12.988c-.363 0-.763.208-.922.585l-1.695 4.016-.61-4.016c-.072-.376-.318-.585-.709-.585h-2.147l1.836 6.672c.034.128.04.27.016.42-.097.556-.61 1.008-1.15 1.008h-1.2c-.306 0-.507.194-.606.637l-.267 1.653h2.117c1.105 0 2.402-.574 3.268-2.16l4.24-8.23H26.83Zm-20.84-1.99c.634 0 .94.261.829.918l-.184 1.07h1.457l-.32 1.881H6.315l-.397 2.33c-.138.81.64.92 1.085.92.089 0 .162-.004.215-.006l-.356 2.097c-.11.012-.224.028-.463.028-1.107 0-3.198-.306-2.787-2.72l.45-2.649H3l.32-1.88h1.05l.34-1.99h1.28Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm18.229 13.073-.374 2.194c.462.242.778.739.778 1.31 0 .754-.546 1.371-1.25 1.46l-.374 2.194c.067.004.134.006.2.006 1.955 0 3.539-1.64 3.539-3.66 0-1.653-1.062-3.05-2.52-3.504Zm-1.665 4.814a1.476 1.476 0 0 1-.777-1.31c0-.75.548-1.372 1.251-1.459l.374-2.193a3.012 3.012 0 0 0-.201-.007c-1.953 0-3.538 1.64-3.538 3.659 0 1.652 1.06 3.051 2.52 3.505l.371-2.195Zm-7.629-4.898h1.252c.634 0 .94.262.827.919l-.137.795c.466-.978 1.478-1.786 2.516-1.786.136 0 .267.028.267.028l-.406 2.372s-.181-.044-.465-.044c-.553 0-1.486.182-2.008 1.256-.125.264-.22.586-.285.975l-.454 2.665H7.71l1.225-7.18Zm20.064 7.513a.759.759 0 0 1-.22.549.709.709 0 0 1-.529.226.712.712 0 0 1-.53-.226.76.76 0 0 1-.219-.549c0-.213.073-.396.22-.546a.712.712 0 0 1 .53-.227c.206 0 .383.076.528.227.146.15.22.332.22.546Zm-.117 0a.644.644 0 0 0-.186-.465.595.595 0 0 0-.446-.194.593.593 0 0 0-.445.194.646.646 0 0 0-.183.465c0 .183.061.34.183.468a.593.593 0 0 0 .445.194.596.596 0 0 0 .446-.195.647.647 0 0 0 .186-.467Zm-.317.423h-.133l-.188-.345h-.124v.345h-.113v-.848h.278a.25.25 0 0 1 .183.074c.05.05.075.11.075.18 0 .119-.058.197-.176.234l.198.36Zm-.137-.594a.145.145 0 0 0-.043-.107.15.15 0 0 0-.112-.042h-.153v.297h.153a.154.154 0 0 0 .112-.042.142.142 0 0 0 .043-.106Z',
      fill: '#fff',
    }),
  );
});
troySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var troy = {
  category: 'brand',
  colorable: false,
  name: 'troy',
  svg: troySvg,
};
